import * as React from 'react';
import antd, { Row, Collapse } from 'antd';
import styled from 'styled-components';
import ScreenHelper from 'components/Styled/ScreenHelper';
import Col, { ColSize } from 'antd/lib/col';

const { Tabs } = antd;

export const StyleUserProfileTab = styled(Tabs)`
 

// .ant-tabs.ant-tabs-left.ant-tabs-vertical.ant-tabs-line{
//     margin-top:100px;
// }
`;

export const PageContainerRow = styled(Row)`
  ${ScreenHelper.up('lg', 'xl')`
     margin-top: 20px;
     padding-top: 10px;
    `}

  ${ScreenHelper.down('lg', 'sm')`
     margin-top: 10px;
     padding-top: 0px;
    `}
`;

declare type ColSpanType = ColSize;

export const PageContainerColLayout: { [key: string]: ColSpanType } = {
  lg: {
    span: 13,
    offset: 6,
  },
  sm: {
    span: 24,
  },
};

export const PageContainerCol = styled(Col)`
text-align: center;
  ${ScreenHelper.up('xl')`
     padding-left: 10px;
     padding-right:10px;
`}

  ${ScreenHelper.down('lg', 'sm')`
     padding-left: 0px;
     padding-right: 0px;
    `}
`;

export const BorderlessCollapse = styled(Collapse)`
  border: 0px;

  div.ant-collapse-item {
    border: 0px;
  }
`;